const request = {
    invalid_input: 'Entrada inválida. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    range_not_satisfiable: 'Intervalo não satisfatório.',
    feature_not_supported: 'Este recurso não é suportado no ambiente atual.',
};
export default Object.freeze(request);
